export enum TRANSLATION_KEYS {
    ENTER_DETAILS_BELOW_TO_SHOW_ESTIMATE = 'ENTER_DETAILS_BELOW_TO_SHOW_ESTIMATE',
}
